import { postMutate } from 'utils/customMutation';
import { fetchData } from 'utils/customUseQuery';
import endPoints from 'utils/platformEndPoints/ossix';

export const userAccountNumbers = () => {
  const { data, isLoading } = fetchData({
    url: endPoints.GetLinkedAccountList,
  });
  return {
    loadUserAccountNumbers: isLoading,
    accountNumbers: data ?? [],
  };
};

export const requestUserAccountNumbers = () => {
  const { pureData, isPending, mutate } = postMutate(
    endPoints.GetLinkedAccountList,
  );

  return {
    loadUserAccountNumbers: isPending,
    accountNumbers: pureData ?? [],
    requestAccountList: mutate,
  };
};

export const getAccountTransactionsSummary = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.GetAccountTransactionsSummary);
  return {
    transactionSummaryData: data,
    loadTransactionSummary: isPending,
    isTransactionSummaryError: isError,
    isTransactionSummarySuccess: isSuccess,
    transactionSummaryMessage: message,
    transactionSummaryError: error,
    mutate,
    clearData,
  };
};

export const requestLinkedAccountBalance = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.GetLinkedAccountBalance);

  return {
    accountBalanceData: data,
    loadAccountBalance: isPending,
    isAccountBalanceError: isError,
    isAccountBalanceSuccess: isSuccess,
    accountBalanceMessage: message,
    accountBalanceError: error,
    mutate,
    clearData,
  };
};
